import React, { useEffect, useRef, useState } from 'react'
import BreadCrum from '../../../../lib/BreadCrum'
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, Divider, Grid, Skeleton, Theme, Typography, useTheme } from '@mui/material'
import { applicantStatusMasters, ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD, MAX_SCHEMES_SELECTED, MPOWER_ACCOUNT_TYPE_MASTER, USER_ROLES, WEEKLYDAYS } from '../../../../utils/constant'
import { CustomeButton } from '../../../../lib/formik/NewFormInputs'
import { BluePlusIcon, DragAndDropIcon, EmailIcon, FailureIcon, Phoneicon } from '../../../../assets/SvgIcons'
import ConfirmRecomment from '../../common/ConfirmRecomment'
import RiskProfilePopup from '../../common/RiskProfilePopup'
import AddtoCardPopup from '../../common/AddtoCardPopup'
import SuccessModal from '../../common/SuccessModal'
import FiveSchemeErrorMessage from '../common/FiveSchemeErrorMessage'
import ValidateDialogBox from '../common/ValidateDialogBox'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { MpowerValidationType, SwitchNavigationProps } from '../../types'
import { RootStateType } from '../../../../redux-store/reducers'
import { getMandateCreationDetails, setCheckedHoldingSchemes, setSelectedAllHoldingsInfo, setSelectedHoldingsIds, setSelectedHoldingsInfo } from '../../../../redux-store/actions/investorProfile'
import { GETINVESTMENTDETAILTYPE, GetInvestmentUserDetails } from '../../../../redux-store/types/api-types'
import { GetSchemeDataResponseType } from '../../../../redux-store/types/investmentdetails'
import { Formik, FormikProps, FormikValues } from '../../../../lib/formik/Formik'
import { MandateCreation } from '../../../../redux-store/types/investorProfile'
import { isModuleAllowed, isOnboardingTypeMinor, maskInfo, toINR } from '../../../../utils/utilityFunctions'
import { useDebounce } from '../../../../utils/useDebounce'
import { getInvestmentDetails, getInvestmentUserDetails, getRiskProfileCheck, submitInvestmentDetails, submitRecomment } from '../../../../redux-store/actions/funds'
import { getSchemeData } from '../../../../redux-store/actions/investmentDetails'
import dayjs from '../../../../utils/dayjs'
import * as Yup from 'yup';
import Card from './Card'
import SwitchCard from './SwitchCard'
import { addToCart, getCartItemsCount, setCartItemsCount } from '../../../../redux-store/actions/cart'
import { AddToCartResponseBody, GetCartItemsCountResponseBody } from '../../../../redux-store/types/cart'
import TransactionsDocumentUpload from '../../../../lib/TransactionsDocumentUpload'
import { HoldingsTableData } from '../holdings/types'
import { stpSchema, switchScheme } from './validations'
import HoldingFundMore from '../../common/HoldingFundMore'
import { getAbbreviatedName } from '../../../commonComponents'

export const handleDateValidation = ({
    ArrayOfDate,
    date,
    weekDaysAllowed,
    frequency,
    isStp
}: {
    ArrayOfDate: Array<string | number>;
    date: dayjs.Dayjs;
    weekDaysAllowed: Array<string>;
    frequency: string;
    isStp?: boolean;
}): boolean => {
    if (isStp && frequency === "WEEKLY") {
        if (!(weekDaysAllowed ?? []).length) return false

        const capitalizedDays = weekDaysAllowed.map(day =>
            day.toString().charAt(0) + day.toString().slice(1).toLowerCase()
        );

        const day = capitalizedDays.map(item => WEEKLYDAYS.indexOf(item))

        return !day?.includes(dayjs(date).day());
    }

    if (ArrayOfDate?.length === 0) {
        return false
    }
    if (typeof ArrayOfDate?.[0] === 'number') {
        return !ArrayOfDate?.includes(dayjs(date).date());
    }

    if (typeof ArrayOfDate?.[0] === 'string') {
        const capitalizedDays = ArrayOfDate.map(day =>
            day.toString().charAt(0) + day.toString().slice(1).toLowerCase()
        );
        const day = capitalizedDays.map(item => WEEKLYDAYS.indexOf(item))
        return !day?.includes(dayjs(date).day());
    }
    return false
}

function SwitchAndStp(): JSX.Element {

    const dispatch = useDispatch()
    const history = useHistory()
    const { pathname, state } = history.location
    const { palette, typography } = useTheme()
    const formRef = useRef<FormikProps<any>>(null);

    const {
        selectedPortfolio,
        selectedPortfolioObj
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);
    const {
        role = '',
        permissions = []
    } = useSelector((store: RootStateType) => store.auth);
    const {
        iwappRmId,
        clientInterfaceCode
    } = useSelector((store: RootStateType) => store.id);
    const { investorRmId = "" } = useSelector((store: RootStateType) => store.sessionData);
    const { locale, currencyCode, currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);
    const {
        selectAllHoldingsInfo,
        selectedHoldingsInfo
    } = useSelector((store: RootStateType) => store.investorProfile);

    //state
    const [details, setDetails] = useState<GETINVESTMENTDETAILTYPE>({} as GETINVESTMENTDETAILTYPE)
    const [isLoading, setIsLoading] = useState(true)
    const [confirmRecomment, setConfirmRecomment] = useState(false)
    const [successModal, setSuccessModal] = useState(false)
    const [switchTo, setSwitchTo] = useState<boolean>(false)
    const [schemeTableData, setSchemeTableData] = useState<GetSchemeDataResponseType>({} as GetSchemeDataResponseType)
    const [selectedScheme, setSelectedScheme] = useState<string>('');
    const [sortObj, setSortObj] = useState<{ orderBy: string, order: 'asc' | 'desc' }>({ orderBy: "schemeName", order: "asc" })
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(1)
    const [tableLoading, setTableLoading] = useState(false)
    const [userDetails, setUserDetails] = useState<GetInvestmentUserDetails>({} as GetInvestmentUserDetails);
    const [orderType, setOrderType] = useState<'order' | 'recomment' | 'investor'>('order');
    const [apiLoading, setApiLoading] = useState<'order' | 'recomment' | 'investor' | "">("");
    const [cartPopup, setCartPopup] = useState<boolean>(false);
    const [submit, setSubmit] = useState<FormikValues>({});
    const [isFiveSchemesDialogVisible, setFiveSchemesDialogVisible] = useState<boolean>(false)
    const [isValidationDialogVisible, setValidationDialogVisible] = useState<boolean>(false)
    const [validationErrorsArray, setValidationErrorsArray] = useState<{ schemeName: string; errorMessage: string }[]>([])
    const [bankDetails, setBankDetails] = useState<Array<MandateCreation>>([] as Array<MandateCreation>);
    const [searchText, setSearchText] = useState<string>('');
    const [riskProfilePopup, setRiskProfilePopup] = useState<boolean>(false);
    const [riskPopupText, setRiskPopupText] = useState<string>('');
    const [riskProfileCheckResponse, setRiskProfileCheckResponse] = useState<{ isSuccess: boolean; displayText: string }>({} as {
        isSuccess: boolean,
        displayText: string
    })
    const [riskPflChkLoading, setRiskPflChkLoading] = useState<boolean>(false);
    const [isDocumentUploadDialogVisible, setDocumentUploadDialogVisible] = useState<boolean>(false);
    const [isDocumentUploadErrorDialogVisible, setDocumentUploadErrorDialogVisible] = useState<boolean>(false);
    const [recommendPlaceOrderResponse, setRecommendPlaceOrderResponse] = useState<any>({})
    const [outgoingSchemeDetails, setOutgoingSchemeDetails] = useState<GETINVESTMENTDETAILTYPE>({} as GETINVESTMENTDETAILTYPE)
    const [isTransactionNotAllowedDialogVisible, setTransactionNotAllowedDialogVisible] = useState<boolean>(false);
    const [isAddMoreHoldingDialogOpen, setAddMoreHoldingDialogOpen] = useState<boolean>(false)
    const [isUserDataLoading, setUserDataLoading] = useState<boolean>(false)
    const [stpSchemesTxnNotAllowed, setStpSchemesTxnNotAllowed] = useState<any>([])
    const [isSameSchemesDialogOpen, setSameSchemesDialogOpen] = useState<boolean>(false)

    //AddMore fund Model
    const [holdingsData, setHoldingsData] = useState<HoldingsTableData[]>([])

    const isSwitchScreen = pathname.split('/')[pathname.split('/').length - 1] === 'switch'

    const initialRouter = pathname?.split('/').filter((item) => item !== '')

    const {
        selectedSchemes = [],
        clientCode = "",
        schemeDetails = [],
        folio = []
    } = (state as {
        selectedSchemes?: HoldingsTableData[];
        clientCode: string;
        schemeDetails: Array<{
            scheme_id: string;
            isReinvestment: string;
        }>;
        folio?: {
            folioId?: string;
            schemeId?: string;
            marketValue: number;
            investedValue: number;
            id: string
        }[]
    }) ?? []

    const rmRouterPath = (isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? [
        {
            name: 'Dashboard',
            path: '/dashboard',
            warning: true,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: initialRouter[1] + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode
            },
            warning: true,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: 'Mutual Fund',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode
            },
            search: "?tab=Holdings"
        },
        {
            name: pathname?.split('/')[pathname?.split('/').length - 1] === 'stp' ? "STP" : 'Switch',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}`,
            ...(pathname?.split('/')[pathname?.split('/').length - 1] === 'stp' ? { textSx: { textTransform: 'uppercase' } } : {})
        },
    ] : [])

    const investorRouterPath = [
        {
            name: 'Dashboard' + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: '/investor-dashboard',
            warning: true,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: 'Mutual Fund',
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode
            },
            search: "?tab=Holdings"
        },

        {
            name: pathname?.split('/')[pathname?.split('/').length - 1] === 'stp' ? "STP" : 'Switch',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
            state: {
                clientCode
            },
            ...(pathname?.split('/')[pathname?.split('/').length - 1] === 'stp' ? { textSx: { textTransform: 'uppercase' } } : {})
        },
    ]

    const stpFilterValidation = details?.investmentDetails?.[0]?.validations?.filter((item) => item?.transactionType === 'STP' && item.frequency)
    const switchFilterValidation = details?.investmentDetails?.[0]?.validations?.filter((item) => item?.transactionType === 'RED')?.[0]

    const validationSchema = isSwitchScreen ? switchScheme(currencySymbol, role, selectedPortfolioObj) : stpSchema(currencySymbol, role, selectedPortfolioObj)

    const getOutgoingSchemeDetails = async () => {
        if (!(selectedSchemes ?? []).length) {
            setIsLoading(false)

            formRef.current?.resetForm({
                values: {
                    ...(formRef.current?.values ?? {}),
                    fund: [],
                }
            })

            return
        }

        try {
            setIsLoading(true)

            const payload = {
                schemeIds: (selectedSchemes ?? []).map((obj: HoldingsTableData) => obj?.schemeId ?? ""),
                portfolioId: selectedPortfolio?.value,
                clientCode,
                rmId: `${investorRmId}`,
                schemeDetails: (selectedSchemes ?? []).map((obj: HoldingsTableData) => ({
                    scheme_id: obj?.schemeId ?? "",
                    isReinvestment: obj?.isReinvest ?? ""
                }))
            }

            const investmentDetailsRes = (await dispatch(getInvestmentDetails(payload))) as unknown | GETINVESTMENTDETAILTYPE;

            setOutgoingSchemeDetails(investmentDetailsRes as GETINVESTMENTDETAILTYPE);

            formRef.current?.resetForm({
                values: {
                    ...(isSwitchScreen ? {
                        fund: [...((investmentDetailsRes as GETINVESTMENTDETAILTYPE)?.investmentDetails || [])]?.map((item, i) => ({
                            // FORM VALUE start
                            switchValue: 'amount',
                            installment: '',
                            entireBalance: false,
                            // FORM VALUE end
                            switchTo: false,
                            isSwitchTransactionNotAllowed: !(
                                ((item?.switchAllowed ?? "").toLowerCase() === "y") &&
                                ((item?.purchaseAllowed ?? "").toLowerCase() === "y")
                            ),
                            outgoingSchDetails: selectedSchemes?.[i] ?? {},
                            outgoingSchInvDetails: item,
                            incomingSchInvDetails: {},
                            folio: folio[i]
                        })),
                    } : {
                        fund: [...((investmentDetailsRes as GETINVESTMENTDETAILTYPE)?.investmentDetails || [])]?.map((item, i) => ({
                            // FORM VALUE start
                            amount: '',
                            frequency: "",
                            swpDate: '',
                            installment: '',
                            stpEndDate: '',
                            firstOrder: false,
                            // FORM VALUE end
                            switchTo: false,
                            outgoingSchDetails: selectedSchemes?.[i] ?? {},
                            outgoingSchInvDetails: item,
                            incomingSchInvDetails: {},
                            incomingSchWeekDays: {},
                            folio: folio[i]
                        })),
                    }),
                    ...((
                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                        ![USER_ROLES.INVESTOR].includes(role) &&
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        documents: formRef.current?.values?.documents ?? []
                    } : {})
                }
            })
        } catch (error) {
            console.log('error', error);
        } finally {
            setIsLoading(false)
        }
    }

    const getUserData = async () => {
        try {
            setUserDataLoading(true)
            if (clientCode) {

                const res1 = (await dispatch(getInvestmentUserDetails({
                    clientCode,
                    portfolioId: selectedPortfolio?.value
                }))) as unknown | GetInvestmentUserDetails;

                if (isSwitchScreen) {
                    const bankDetailsRes = (await dispatch(getMandateCreationDetails({
                        clientCode,
                        portfolioId: selectedPortfolio?.value
                    }))) as unknown as any

                    setBankDetails(bankDetailsRes);
                }

                setUserDetails(res1 as GetInvestmentUserDetails);
            }
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setUserDataLoading(false)
        }
    }

    useEffect(() => {
        const fetchAll = async () => {
            await Promise.allSettled([getOutgoingSchemeDetails(), getUserData()])
        }
        if (clientCode) fetchAll()
    }, [clientCode])

    const handleConfromRecomment = async (values: FormikValues) => {
        try {
            setApiLoading('recomment')

            const payload = (values?.fund ?? []).map((obj: FormikValues) => ({
                clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                amcId: obj?.incomingSchInvDetails?.fundAmcId ?? "",
                schemeId: obj?.outgoingSchInvDetails?.schemeId ?? "",
                schemeName: obj?.outgoingSchDetails?.schemeName ?? "",
                categoryName: obj?.outgoingSchDetails?.categoryName ?? "",
                subCategoryName: obj?.outgoingSchDetails?.subCategoryName ?? "",
                riskType: obj?.outgoingSchDetails?.riskType ?? "",
                navDate: obj?.outgoingSchDetails?.navDate ?? "",
                navValue: obj?.outgoingSchDetails?.navValue ?? "",
                folioNo: obj?.outgoingSchDetails?.folioNo ?? "",
                recommendedDate: dayjs().format("DD/MM/YYYY"),
                imgUrl: '',
                toSchemeId: obj?.incomingSchInvDetails?.schemeId ?? "",
                toSchemeName: obj?.incomingSchInvDetails?.fundName ?? "",
                toCategoryName: obj?.incomingSchInvDetails?.fundType ?? "",
                toSubCategoryName: obj?.incomingSchInvDetails?.fundCap ?? "",
                toRiskType: obj?.incomingSchInvDetails?.riskType ?? "",
                buySellType: isSwitchScreen ? 'SWITCH' : 'STP',
                email: userDetails.email,
                mobileNo: userDetails.mobile,
                ...(isSwitchScreen ? {
                    transMode: obj.switchValue === "amount" ? "A" : "U",
                    recommendedAmount: obj.switchValue === "amount" ? `${obj.installment}` : '',
                    recommendedUnits: obj.switchValue === "amount" ? "" : `${obj.installment}`,
                    allUnitsFlag: obj.entireBalance ? "Y" : "N",
                } : {
                    frequency: obj.frequency,
                    recommendedAmount: `${obj.amount}`,
                    noOfInstallments: obj.frequency === 'DAILY' && !isSwitchScreen ? '0' : `${obj.installment}`,
                    systematicDate: dayjs(obj.swpDate).format("DD/MM/YYYY"),
                    recommendedDate: dayjs().format("DD/MM/YYYY"),
                    endDate: obj.frequency === 'DAILY' && !isSwitchScreen ? dayjs(obj.stpEndDate).format("DD/MM/YYYY") : '',
                    firstOrderFlag: obj?.firstOrder ? "Y" : "N",
                }),
                portfolioId: selectedPortfolio.value,
                investedValue: `${obj?.outgoingSchDetails?.investedValue ?? ""}`,
                marketValue: `${obj?.outgoingSchDetails?.marketValue ?? ""}`,
                rmId: `${investorRmId}`
            }))


            const res = (await dispatch(submitRecomment(payload as any))) as unknown as {
                isSuccess: boolean,
                message: string,
                response: Array<any>
            };

            if (res?.isSuccess) {
                setRecommendPlaceOrderResponse(res)

                setConfirmRecomment(false)
                dispatch(setSelectedHoldingsIds([]))
                dispatch(setCheckedHoldingSchemes([]))
                dispatch(setSelectedHoldingsInfo([]))
                dispatch(setSelectedAllHoldingsInfo([]))

                setSuccessModal(true);
            } else if (!res?.isSuccess) {
                setConfirmRecomment(false)
                if (res?.message) {
                    setFiveSchemesDialogVisible(true)
                } else {
                    setValidationErrorsArray(
                        res?.response
                            .filter(data => !data.isSuccess)
                            .map(data => ({
                                schemeName: data.schemeName,
                                errorMessage: data.message
                            }))
                    )
                    setValidationDialogVisible(true)
                }
            }

        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setApiLoading('');
        }
    }

    const handleConformOrder = async (values: FormikValues) => {
        const payload = (values?.fund ?? []).map((obj: FormikValues) => {

            const calculatedSwitchAmount = obj.switchValue === "amount" ?
                Number(obj?.installment ?? "") :
                (Number(obj?.installment ?? "") * Number(obj?.outgoingSchDetails?.navValue ?? ""))

            const calculatedSwitchUnits = obj.switchValue === "unit" ?
                Number(obj?.installment ?? "") :
                ((Number(obj?.installment ?? "") / Number(obj?.outgoingSchDetails?.navValue ?? "")))


            return {
                clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                portfolioId: selectedPortfolio?.value,
                portfolioName: selectedPortfolio?.label,
                "fromScheme": obj?.outgoingSchInvDetails?.schemeId ?? "",
                "toScheme": obj?.incomingSchInvDetails?.schemeId ?? "",
                "fromSchemeName": obj?.outgoingSchDetails?.schemeName ?? "",
                "toSchemeName": obj?.incomingSchInvDetails?.fundName ?? "",
                "folio": obj?.outgoingSchDetails?.folioNo ?? "",
                "isRecommended": true,
                "isDiy": false,
                "rmId": `${investorRmId}`,
                "trType": isSwitchScreen ? "SWITCH" : "STP",
                ...(isSwitchScreen ? {
                    switchMode: obj.switchValue === "amount" ? "A" : "U",
                    // amount: obj.switchValue === "amount" ? obj.installment : '',
                    amount: calculatedSwitchAmount ?? "",
                    allUnitsFlag: obj.entireBalance ? "Y" : "N",
                    // units: obj.switchValue === "unit" ? obj.installment : '',
                    units: calculatedSwitchUnits ?? ""
                } : {
                    amount: obj.amount,
                    frequency: obj.frequency,
                    transactionStartDate: dayjs(obj.swpDate).format("DD/MM/YYYY"),
                    noOfTransfers: obj.installment ? obj.installment : 0,
                    transactionEndDate: obj.frequency === 'DAILY' && !isSwitchScreen ? dayjs(obj.stpEndDate).format("DD/MM/YYYY") : '',
                    firstOrderFlag: obj?.firstOrder ? "Y" : "N",
                }),
                amcId: obj?.incomingSchInvDetails?.fundAmcId ?? "",
                "cartId": null,
            }
        })

        try {
            setApiLoading('order')

            const res = (await dispatch(submitInvestmentDetails({
                accountType: selectedPortfolioObj?.portfolioAccountType,
                orderDetails: payload,
                ...((
                    ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                    ![USER_ROLES.INVESTOR].includes(role) &&
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    documents: formRef?.current?.values?.documents?.filter((obj: {
                        documentId: string;
                        documentType: string;
                    }) => obj.documentId !== "" && obj.documentType !== "")
                } : {})
            }))) as unknown as {
                isSuccess: boolean,
                message: string,
                ordersValidation: Array<any>
            };

            if (res.isSuccess) {
                setRecommendPlaceOrderResponse(res)

                setConfirmRecomment(false)
                dispatch(setSelectedHoldingsIds([]))
                dispatch(setCheckedHoldingSchemes([]))
                dispatch(setSelectedHoldingsInfo([]))
                dispatch(setSelectedAllHoldingsInfo([]))

                setSuccessModal(true);
            } else if (!res.isSuccess) {
                setConfirmRecomment(false)
                if (res.message) {
                    setFiveSchemesDialogVisible(true)
                } else {
                    setValidationErrorsArray(
                        res.ordersValidation
                            .filter(data => !data.isSuccess)
                            .map(data => ({
                                schemeName: data.schemeName,
                                errorMessage: data.message
                            }))
                    )
                    setValidationDialogVisible(true)
                }
            }
        } catch (err) {
            console.log('error', err);
        } finally {
            setConfirmRecomment(false);
            setRiskProfilePopup(false);
            setApiLoading("")
        }
    };

    const handleSuccess = () => {
        history.push('/cart', { clientCode })
    }

    const hasDuplicateSchemes = (arr: any) => {
        const codeSet = new Set();

        for (const item of arr) {
            const key = `${item.isinCode}-${item.folioNo}`;
            if (codeSet.has(key)) {
                return true;
            }
            codeSet.add(key);
        }

        return false;
    }

    const handleSameSchemeDialogClose = () => {
        setSameSchemesDialogOpen(false)
    }

    const handleSameSchemeDialogConfirm = async () => {

        handleSameSchemeDialogClose()

        if (!formRef.current) {
            return
        }

        const { values } = formRef.current

        if (orderType === 'investor') {
            try {
                setApiLoading('investor');

                const payload = (values?.fund ?? []).map((obj: FormikValues) => ({
                    trType: isSwitchScreen ? "SWITCH" : "STP",
                    isDividendReinvestment: obj?.incomingSchInvDetails?.divReinvestAllowed ?? "",
                    mPowerScheme: obj?.incomingSchInvDetails?.mPowerScheme ?? "",
                    categoryName: obj?.outgoingSchDetails?.categoryName ?? "",
                    clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                    exitLoad: "",
                    navValue: `${obj?.outgoingSchDetails?.navValue ?? ""}`,
                    balanceUnits: `${obj?.outgoingSchDetails?.units ?? ""}`,
                    riskType: obj?.outgoingSchDetails?.riskType ?? "",
                    schemeId: obj?.outgoingSchInvDetails?.schemeId ?? "",
                    schemeName: obj?.outgoingSchDetails?.schemeName ?? "",
                    subCategoryName: obj?.outgoingSchDetails?.subCategoryName ?? "",
                    y3Returns: "",
                    mandateId: "",
                    navDate: obj?.outgoingSchDetails?.navDate ?? "",
                    folioNo: obj?.outgoingSchDetails?.folioNo ?? "",
                    investedValue: `${obj?.outgoingSchDetails?.investedValue ?? ""}`,
                    marketValue: `${obj?.outgoingSchDetails?.marketValue ?? ""}`,
                    portfolioId: selectedPortfolio.value,
                    toSchemeId: obj?.incomingSchInvDetails?.schemeId ?? "",
                    toSchemeName: obj?.incomingSchInvDetails?.fundName ?? "",
                    toCategoryName: obj?.incomingSchInvDetails?.fundType ?? "",
                    toRiskType: obj?.incomingSchInvDetails?.riskType ?? "",
                    toSubCategoryName: obj?.incomingSchInvDetails?.fundCap ?? "",
                    ...(isSwitchScreen ? {
                        transMode: obj.switchValue === "amount" ? "A" : "U",
                        amount: obj.switchValue === "amount" ? `${obj.installment}` : '', // if transmode- A , AMOUNT SHOULD HAVE A VALUE
                        units: obj.switchValue === "amount" ? '' : `${obj.installment}`, // if transmode- U , UNITS SHOULD HAVE A value
                    } : {
                        frequency: obj.frequency,
                        amount: obj.amount,
                        noOfInstallment: obj.frequency === 'DAILY' && !isSwitchScreen ? 0 : obj.installment,
                        sipDate: dayjs(obj.swpDate).format("DD/MM/YYYY"),
                        transMode: 'A',
                        endDate: obj.frequency === 'DAILY' && !isSwitchScreen ? dayjs(obj.stpEndDate).format("DD/MM/YYYY") : '',
                        firstOrderFlag: obj?.firstOrder ? "Y" : "N",
                    }),
                    amcId: obj?.outgoingSchDetails?.amcId ?? "",
                    rmId: `${investorRmId}`,
                    allUnitsFlag: obj.entireBalance ? "Y" : "N"
                }))

                const res = ((await dispatch(addToCart(payload as any))) as unknown) as AddToCartResponseBody;
                if (res.isSuccess) {
                    setConfirmRecomment(false)
                    const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                        clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                        portfolioId: selectedPortfolio?.value
                    })) as unknown as Promise<GetCartItemsCountResponseBody>)

                    if (isSuccess) {
                        dispatch(setCartItemsCount(cartItemsCount));
                        dispatch(setSelectedHoldingsInfo([]))
                        dispatch(setSelectedAllHoldingsInfo([]))
                    }

                    setCartPopup(true)
                } else if (!res.isSuccess) {
                    setConfirmRecomment(false)
                    if (res.message) {
                        setFiveSchemesDialogVisible(true)
                    } else {
                        setValidationErrorsArray(
                            res.response
                                .filter(data => !data.isSuccess)
                                .map(data => ({
                                    schemeName: data.schemeName,
                                    errorMessage: data.message
                                }))
                        )
                        setValidationDialogVisible(true)
                    }
                }
            } catch (err) {
                console.log(err)
            } finally {
                setApiLoading("");
            }
        } else {
            if (orderType === 'order') {
                try {
                    setRiskPflChkLoading(true)
                    const riskProfileCheckRes = (await dispatch(getRiskProfileCheck({
                        clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                        schemeCode: (values?.fund ?? []).map((obj: FormikValues) => obj?.incomingSchInvDetails?.schemeId)
                    }))) as unknown as {
                        isSuccess: boolean,
                        displayText: string
                    }

                    setRiskProfileCheckResponse(riskProfileCheckRes ?? {})

                    if (!riskProfileCheckRes?.isSuccess) {
                        setRiskProfilePopup(true)
                        setRiskPopupText(riskProfileCheckRes?.displayText || "Risk Profile Expired!")
                    } else if (riskProfileCheckRes?.isSuccess) {
                        if (`${riskProfileCheckRes?.displayText ?? ""}`.length > 0) {
                            setRiskProfilePopup(true)
                            setRiskPopupText(riskProfileCheckRes.displayText)
                        } else {
                            setConfirmRecomment(true)
                        }
                    }
                } catch (e) {
                    console.log(e)
                } finally {
                    setRiskPflChkLoading(false)
                }
            } else {
                setConfirmRecomment(true)
            }
        }
    }

    const onSubmit = async (values: FormikValues) => {

        if ((
            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
            ![USER_ROLES.INVESTOR].includes(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        )) {
            if (values?.documents?.length === 1 && (values?.documents[0]?.documentId === '' || values?.documents[0]?.documentType === '')) {
                setDocumentUploadErrorDialogVisible(true)
                return
            }
        }

        if (!isSwitchScreen) {
            const stpTxnNotAllowedSchemes = []

            for (const fundObj of (values?.fund ?? [])) {
                const stpOutgoingSchemeValidationObj = (fundObj?.outgoingSchInvDetails?.validations ?? [])?.find((obj: any) => (
                    ((obj?.transactionType ?? "")?.toLowerCase() === "stp") &&
                    ((obj?.frequency ?? "")?.toLowerCase() === (fundObj?.frequency ?? "")?.toLowerCase())
                ))

                const stpIncomingSchemeValidationObj = (fundObj?.incomingSchInvDetails?.validations ?? [])?.find((obj: any) => (
                    ((obj?.transactionType ?? "")?.toLowerCase() === "stp") &&
                    ((obj?.frequency ?? "")?.toLowerCase() === (fundObj?.frequency ?? "")?.toLowerCase())
                ))

                if (!(
                    ((stpOutgoingSchemeValidationObj?.ASTPRegOUT ?? "")?.toLowerCase() === "y") &&
                    ((stpIncomingSchemeValidationObj?.ASTPRegIN ?? "")?.toLowerCase() === "y")
                )) {
                    stpTxnNotAllowedSchemes.push(fundObj?.outgoingSchInvDetails)
                }
            }

            if (stpTxnNotAllowedSchemes.length > 0) {
                setStpSchemesTxnNotAllowed(stpTxnNotAllowedSchemes)
                setTransactionNotAllowedDialogVisible(true)
                return
            }
        }

        // Checking if multiple orders with the same scheme/folio combination are there ot not

        const hasDuplicates = hasDuplicateSchemes(
            (values?.fund ?? [])?.map((obj: any) => ({ ...(obj?.outgoingSchDetails ?? {}) }))
        )

        if (hasDuplicates) {
            setSameSchemesDialogOpen(true)
            return
        } else {
            handleSameSchemeDialogConfirm()
        }
    }

    const handleSuccessPopup = () => {
        if (role === USER_ROLES.INVESTOR) {
            history.push('/investor-dashboard')
        } else {
            history.push('/dashboard')
        }
    }

    const handleCloseFiveSchemesDialog = () => {
        setFiveSchemesDialogVisible(false)
    }

    const handleValidationDialogClose = () => {
        setValidationDialogVisible(false)
    }

    const handleRiskProfilePopup = (btnText: string) => {
        setRiskProfilePopup(false);

        if (btnText === 'continue') {
            setConfirmRecomment(true);
        }
    }

    const handleDocumentUploadDialogOpen = () => {
        setDocumentUploadDialogVisible(true)
    }

    const handleDocumentUploadDialogClose = () => {
        setDocumentUploadDialogVisible(false)
    }

    const handleDocumentUploadErrorDialogClose = () => {
        setDocumentUploadErrorDialogVisible(false)
    }

    const handleTransactionNotAllowedDialogClose = () => {
        setTransactionNotAllowedDialogVisible(false)
        setStpSchemesTxnNotAllowed([])
    }

    const handleDelete = (checkId: string, selectedUniqueId: string) => {

        setOutgoingSchemeDetails((pre: GETINVESTMENTDETAILTYPE) => {

            const result = pre?.investmentDetails?.filter((item) => item?.schemeId !== checkId);

            const modifiedSelectedSchemes = selectedSchemes?.filter((item: any) => item.uniqueId !== selectedUniqueId);

            history.replace({
                state: ({
                    selectedSchemes: modifiedSelectedSchemes,
                    clientCode,
                    schemeDetails: (modifiedSelectedSchemes ?? [])
                        .map(item => ({
                            scheme_id: item?.schemeId ?? "-",
                            isReinvestment: item?.isReinvest ?? "-"
                        })),
                    folio: (modifiedSelectedSchemes ?? [])
                        .map(item => ({
                            folioId: item.folioId,
                            schemeId: item.scheme,
                            id: item.id,
                            marketValue: item.marketValue,
                            investedValue: item.investedValue,
                        })),
                })
            })

            return { ...pre, result };
        })
    }

    const addFunds = async (schemes: any) => {
        // schemes currently in formik
        const currentSchemesArr = (formRef.current?.values?.fund ?? []).map((obj: any) => obj.outgoingSchDetails)

        // latest added schemes excluding the schemes in formik
        const latestAddedSchemes = schemes?.filter((obj: any) => !currentSchemesArr.find((currObj: any) => currObj.uniqueId === obj.uniqueId))

        if (!(latestAddedSchemes ?? []).length) {
            return
        }

        try {
            setIsLoading(true);
            const payload = {
                // passing only those schemeIds which have been added via Add more funds, NOT passing those schemes already in Formik
                schemeIds: (latestAddedSchemes ?? [])?.map((item: any) => item?.scheme ?? ""),
                portfolioId: selectedPortfolio?.value,
                clientCode: clientCode,
                rmId: `${investorRmId}`,
                schemeDetails: (latestAddedSchemes ?? [])?.map((obj: any) => ({
                    scheme_id: obj?.scheme ?? "",
                    isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
                }))
            }

            const res = (await dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown

            setOutgoingSchemeDetails(res as GETINVESTMENTDETAILTYPE);

            // extracting ISIN codes from the response
            const responseIsinCodes = ((res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []).map((item: any) => item.isinCode) as Array<string>

            // Filtering out those schemes for which we did not get the api response based on the isin code
            const modifiedLatestAddedSchemes = latestAddedSchemes.filter((item: any) => responseIsinCodes.includes(item.isinCode));

            const formInitial = [...(res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []].map((item, i) => {
                const addedFolio = {
                    folioId: modifiedLatestAddedSchemes[i].folioId,
                    schemeId: modifiedLatestAddedSchemes[i].scheme,
                    id: modifiedLatestAddedSchemes[i].id,
                    marketValue: modifiedLatestAddedSchemes[i].marketValue,
                    investedValue: modifiedLatestAddedSchemes[i].investedValue,
                }

                if (isSwitchScreen) {
                    return {
                        switchValue: 'amount',
                        installment: '',
                        entireBalance: false,
                        switchTo: false,
                        isSwitchTransactionNotAllowed: !(
                            ((item?.switchAllowed ?? "").toLowerCase() === "y") &&
                            ((item?.purchaseAllowed ?? "").toLowerCase() === "y")
                        ),
                        outgoingSchDetails: modifiedLatestAddedSchemes[i],
                        outgoingSchInvDetails: item,
                        incomingSchInvDetails: {},
                        folio: addedFolio
                    }
                }
                return {
                    amount: '',
                    frequency: "",
                    swpDate: '',
                    installment: '',
                    stpEndDate: '',
                    firstOrder: false,
                    switchTo: false,
                    outgoingSchDetails: modifiedLatestAddedSchemes[i],
                    outgoingSchInvDetails: item,
                    incomingSchInvDetails: {},
                    incomingSchWeekDays: {},
                    folio: addedFolio
                }
            })

            const currentForm = [...formRef.current?.values?.fund]
            // const newFrom = [...formInitial]

            // const getId = (item: any) => item?.map((obj: any) => obj.folio.id)

            // const currentSchemeId = getId([...currentForm])
            // const newSchemeId = getId([...newFrom])

            // const filteredNewData = newFrom.filter((item: any) => !currentSchemeId.includes(item.folio.id))
            // const filteredCurrentForm = currentForm.filter((item: any) => newSchemeId.includes(item.folio.id))

            const updatedFundsArray = [...currentForm, ...formInitial]

            history.replace({
                state: ({
                    selectedSchemes: updatedFundsArray
                        .map(obj => obj?.outgoingSchDetails ?? {})
                        .map(item => ({
                            ...item,
                            folioId: item.folioNo,
                            scheme: item.schemeId,
                            id: item.id,
                            marketValue: item.marketValue,
                            investedValue: item.investedValue,
                            isReinvestment: item?.isReinvest
                        })),
                    clientCode,
                    schemeDetails: updatedFundsArray
                        .map(obj => obj?.outgoingSchDetails ?? {})
                        .map(item => ({
                            scheme_id: item?.schemeId ?? "-",
                            isReinvestment: item?.isReinvest ?? "-"
                        })),
                    folio: updatedFundsArray
                        .map(obj => obj?.outgoingSchDetails ?? {})
                        .map(item => ({
                            folioId: item.folioId,
                            schemeId: item.scheme,
                            id: item.id,
                            marketValue: item.marketValue,
                            investedValue: item.investedValue,
                        }))
                })
            })

            dispatch(setSelectedHoldingsInfo(
                updatedFundsArray.map(obj => ({
                    checkedId: obj?.outgoingSchDetails?.id,
                    schemeId: obj?.outgoingSchDetails?.scheme,
                    folioNo: obj?.outgoingSchDetails?.folioNo ?? "",
                    uniqueId: obj?.outgoingSchDetails?.uniqueId
                }))))

            dispatch(setSelectedAllHoldingsInfo(
                updatedFundsArray.map(obj => obj?.outgoingSchDetails ?? {})
            ))

            formRef.current?.resetForm({
                values: {
                    fund: updatedFundsArray,
                    ...((
                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                        ![USER_ROLES.INVESTOR].includes(role) &&
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        documents: formRef.current?.values?.documents ?? []
                    } : {}),
                }
            })
        } catch (err) {
            console.log('error', err)
        } finally {
            setIsLoading(false)
        }
    };

    const handleProceed = () => {
        const data = selectAllHoldingsInfo.map(item => ({
            ...item,
            folioId: item.folioNo,
            scheme: item.schemeId,
            id: item.id,
            marketValue: item.marketValue,
            investedValue: item.investedValue,
            isReinvestment: item?.isReinvest
        }))

        const checkedIds = data.map((obj) => obj.scheme)

        const folioData = data.map((obj) => ({
            folioId: obj.folioId,
            schemeId: obj.scheme,
            id: obj.id,
            marketValue: obj.marketValue,
            investedValue: obj.investedValue
        }))

        const schemeDetails = selectAllHoldingsInfo?.map((obj) => ({
            scheme_id: obj?.schemeId ?? "-",
            isReinvestment: obj?.isReinvest ?? "-"
        }))

        dispatch(setSelectedHoldingsIds([...[]]))
        dispatch(setCheckedHoldingSchemes([...checkedIds]))

        // history.replace({
        //     state: ({
        //         selectedSchemes: [...data],
        //         clientCode,
        //         schemeDetails,
        //         folio: folioData
        //     })
        // })

        setAddMoreHoldingDialogOpen(false)

        addFunds([...data])
    }

    let successMessage = ""

    if (orderType === 'recomment') {
        successMessage = "Your Recommendation is sent successfully to the Investor."
    } else {
        if (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD && selectedPortfolioObj?.portfolioAccountType) {
            if (![USER_ROLES.INVESTOR].includes(role) &&
                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                MPOWER_ACCOUNT_TYPE_MASTER["POA"]) {
                successMessage = `Your order${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} with order ID${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.map((obj: any) => obj?.id)?.join(', ')} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "are" : "is"} sent to the checker for approval.`
            }
            if (![USER_ROLES.INVESTOR].includes(role) &&
                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                MPOWER_ACCOUNT_TYPE_MASTER["EXY"]
            ) {
                successMessage = `Your order${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} with order ID${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.map((obj: any) => obj?.id)?.join(', ')} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "are" : "is"} successfully sent to the investor for approval. Once authorized and approved the order will be placed.`
            }
        } else {
            successMessage = "The transaction link will be sent via email by BSE Star for authorisation and completion of the transaction."
        }

    }

    const initialValues = isSwitchScreen ? {
        fund: [{
            switchValue: 'amount',
            installment: '',
            entireBalance: false,
            switchTo: false,
            isSwitchTransactionNotAllowed: false,
            outgoingSchDetails: {},
            outgoingSchInvDetails: {},
            incomingSchInvDetails: {},
            folio: {}
        }],
        ...((
            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
            ![USER_ROLES.INVESTOR].includes(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        ) ? {
            documents: [{
                documentId: "",
                documentType: ""
            }]
        } : {})
    } : {
        fund: [{
            amount: '',
            frequency: "",
            swpDate: '',
            installment: '',
            stpEndDate: '',
            firstOrder: false,
            switchTo: false,
            outgoingSchDetails: {},
            outgoingSchInvDetails: {},
            incomingSchInvDetails: {},
            incomingSchWeekDays: {},
            folio: {}
        }],
        ...((
            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
            ![USER_ROLES.INVESTOR].includes(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        ) ? {
            documents: [{
                documentId: "",
                documentType: ""
            }]
        } : {})
    }

    const isMinor = isOnboardingTypeMinor(userDetails?.application?.onboardingType || '');
    const investorName = isMinor ? `${userDetails?.application?.applicants?.[0]?.minorFirstName} ${userDetails?.application?.applicants?.[0]?.minorLastName}` : userDetails?.name;


    return (
        <>
            <BreadCrum array={![USER_ROLES.INVESTOR].includes(role) ? rmRouterPath : investorRouterPath} />
            <Typography
                variant='h1'
                mt={2}
                fontSize={{ sm: '16px', xs: '16px', md: '24px', lg: '24px' }}
                color={palette.text.primary}
            >
                {isSwitchScreen ? 'Switch' : 'STP (Systematic Transfer Plan)'}
            </Typography>
            <Formik
                innerRef={formRef}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {(formik) => {
                    let totalAmount = 0
                    let totalUnits = 0

                    if (isSwitchScreen) {
                        totalAmount = (formik.values?.fund ?? []).reduce((acc: number, curr: FormikValues) => {
                            return (curr?.switchValue === 'amount') ? acc + Number(curr?.installment ?? 0) : acc
                        }, 0)

                        totalUnits = (formik.values?.fund ?? []).reduce((acc: number, curr: FormikValues) => {
                            return (curr?.switchValue === 'unit') ? acc + Number(curr?.installment ?? 0) : acc
                        }, 0)
                    } else {
                        totalAmount = (formik.values?.fund ?? []).reduce((acc: number, curr: FormikValues) => {
                            return (acc + Number(curr?.amount ?? 0))
                        }, 0)
                    }

                    return (
                        <>
                            <Grid container marginTop={2} spacing={2}>
                                <Grid
                                    item
                                    lg={8}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    sx={{
                                        display: 'flex',
                                        rowGap: '25px',
                                        flexDirection: 'column'
                                    }}
                                >
                                    {(formik?.values?.fund ?? []).map((obj: FormikValues, index: number) => (
                                        <>
                                            <Card
                                                key={`${obj?.outgoingSchDetails?.isinCode}-${index}`}
                                                id={index}
                                                isLoading={isLoading}
                                                isSubmitting={!!apiLoading || riskPflChkLoading}
                                                bankDetails={bankDetails}
                                                handleDelete={handleDelete}
                                            />
                                        </>
                                    ))}
                                    {selectedSchemes.length < MAX_SCHEMES_SELECTED && (
                                        <Box
                                            sx={{
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            {isLoading && (
                                                <Skeleton
                                                    variant="rectangular"
                                                    width={200}
                                                    height={30}
                                                />
                                            )}
                                            {!isLoading && (
                                                <Button
                                                    variant="text"
                                                    onClick={() => setAddMoreHoldingDialogOpen(true)}
                                                    sx={{
                                                        gap: '10px',
                                                        '&:hover': {
                                                            background: 'transparent',
                                                        },
                                                        '&:disabled': {
                                                            opacity: 0.5
                                                        }
                                                    }}
                                                    disabled={!!apiLoading || riskPflChkLoading}
                                                >
                                                    <BluePlusIcon />
                                                    <Typography
                                                        variant="body_500"
                                                        color={palette.text.secondary}
                                                        sx={{
                                                            textDecoration: 'dashed',
                                                            textDecorationColor: palette.primary[500],
                                                            textDecorationThickness: '2px',
                                                        }}
                                                    >
                                                        Add More Holding
                                                    </Typography>
                                                </Button>
                                            )}
                                        </Box>
                                    )}
                                </Grid>
                                <Grid item lg={4} md={12} sm={12} xs={12}>
                                    {(
                                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                        ![USER_ROLES.INVESTOR].includes(role) &&
                                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                    ) && (
                                            <Box
                                                sx={{
                                                    background: palette.background.paper,
                                                    padding: '20px',
                                                    borderRadius: '20px',
                                                    marginBottom: "20px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    flexDirection: "column"
                                                }}
                                                boxShadow={1}
                                            >
                                                <Typography
                                                    variant="body_500"
                                                    sx={{
                                                        lineHeight: "20px",
                                                        letterSpacing: "0.02px",
                                                        color: `${palette.text.secondary}B2`,
                                                    }}
                                                >
                                                    You can add minimum 1 attachment and maximum 5 attachments
                                                </Typography>
                                                <Typography
                                                    variant='body_400'
                                                    sx={{
                                                        color: palette.text.primary,
                                                        alignSelf: "flex-start",
                                                        marginTop: "10px"
                                                    }}
                                                >
                                                    Documents Uploaded: {
                                                        formik?.values?.documents?.filter((obj: {
                                                            documentId: string;
                                                            documentType: string;
                                                        }) => obj.documentId !== "" && obj.documentType !== "")?.length ?? "0"
                                                    }
                                                </Typography>
                                                <Button
                                                    sx={{
                                                        ...typography.body_500,
                                                        color: palette.primary[500],
                                                        padding: "5px",
                                                        fontWeight: 600,
                                                        marginTop: "15px"
                                                    }}
                                                    onClick={handleDocumentUploadDialogOpen}
                                                    disabled={isLoading || !!apiLoading}
                                                >
                                                    Upload Documents
                                                </Button>
                                            </Box>
                                        )}
                                    <Box
                                        sx={{
                                            background: palette.background.paper,
                                            padding: '25px 30px 30px',
                                            borderRadius: '20px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '35px'
                                        }}
                                        boxShadow={1}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}
                                        >
                                            {isUserDataLoading ?
                                                <CircularProgress /> :
                                                // <img
                                                //     src={`https://ui-avatars.com/api/?name=${investorName || ''}&background=${palette.primary[50]?.slice(1)}&color=${palette.primary[500]?.slice(1)}`}
                                                //     style={{ borderRadius: '50%' }}
                                                //     alt="Bank name" />
                                                getAbbreviatedName(investorName ?? '')
                                            }
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    rowGap: "5px",
                                                    flex: 1
                                                }}
                                            >
                                                {isUserDataLoading && (
                                                    <>
                                                        <Skeleton variant='text' animation="wave" />
                                                        <Skeleton variant='text' animation="wave" />
                                                    </>
                                                )}
                                                {!isUserDataLoading && (
                                                    <>
                                                        <Typography
                                                            variant='h2'
                                                            sx={(theme: Theme) => ({
                                                                lineHeight: "25px",
                                                                letterSpacing: "0.01px",
                                                                color: theme.palette.text.primary,
                                                                marginBottom: "5px"
                                                            })}
                                                        >
                                                            {maskInfo(investorName || '')}
                                                        </Typography>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                columnGap: "5px"
                                                            }}
                                                        >
                                                            <Typography
                                                                variant='body_500'
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.primary,
                                                                    whiteSpace: "nowrap"
                                                                })}
                                                            >
                                                                Client Code:
                                                            </Typography>
                                                            <Typography
                                                                variant='body_500'
                                                                sx={(theme: Theme) => ({
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    wordBreak: "break-word",
                                                                    maxWidth: "100%",
                                                                })}
                                                            >
                                                                {clientCode ?? "-"}
                                                            </Typography>
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "5px",
                                                                flexWrap: "wrap",
                                                            }}
                                                        >
                                                            {/* <Typography
                                                                variant='body_500'
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    textTransform: "capitalize"
                                                                })}
                                                            >
                                                                {userDetails?.applicationType ?? ""}
                                                            </Typography>
                                                            <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            /> */}
                                                            <Typography
                                                                variant='body_500'
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    textTransform: "capitalize"
                                                                })}
                                                            >
                                                                {selectedPortfolio?.label ?? ""}
                                                            </Typography>
                                                            <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary
                                                                })}
                                                            >
                                                                {userDetails?.accountType ?? ""}
                                                            </Typography>
                                                            <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    textTransform: "capitalize"
                                                                })}
                                                            >
                                                                {userDetails?.modeOfHolding ?? ""}
                                                            </Typography>
                                                            <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary
                                                                })}
                                                            >
                                                                {/* {
                                                                    isMinor
                                                                        ? "Minor"
                                                                        :
                                                                        userDetails?.status ?
                                                                            applicantStatusMasters[userDetails.status] ?
                                                                                applicantStatusMasters[userDetails.status] : userDetails.status
                                                                            : "N/A"
                                                                } */}
                                                                {userDetails?.investorType ?? ""}
                                                            </Typography>
                                                            {(`${userDetails?.isFamilyHead ?? ""}`.toLowerCase() === "y") && (
                                                                <>
                                                                    <Box
                                                                        sx={{
                                                                            width: "3px",
                                                                            height: "3px",
                                                                            backgroundColor: "text.secondary",
                                                                            alignSelf: "center",
                                                                            borderRadius: "50%"
                                                                        }}
                                                                    />
                                                                    <Typography
                                                                        variant="body_500"
                                                                        sx={(theme: Theme) => ({
                                                                            lineHeight: "20px",
                                                                            letterSpacing: "0.02px",
                                                                            color: theme.palette.text.secondary
                                                                        })}
                                                                    >
                                                                        Head Of Family
                                                                    </Typography>
                                                                </>
                                                            )}
                                                        </Box>
                                                    </>
                                                )}
                                            </Box>
                                        </Box>
                                        <Box width={'100%'}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px',
                                                    width: '100%'
                                                }}
                                            >
                                                <EmailIcon />
                                                {isUserDataLoading ? (
                                                    <Skeleton
                                                        variant='text'
                                                        animation="wave"
                                                        width={'100%'}
                                                    />
                                                ) : (
                                                    <Typography
                                                        variant='body_500'
                                                        fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}
                                                        color={palette.text.primary}
                                                    >
                                                        {maskInfo(userDetails.email || '')}
                                                    </Typography>
                                                )}
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px',
                                                    width: '100%'
                                                }}
                                            >
                                                <Phoneicon />
                                                {isUserDataLoading ? (
                                                    <Skeleton
                                                        variant='text'
                                                        animation="wave"
                                                        width={'100%'}
                                                    />
                                                ) : (
                                                    <Typography
                                                        variant='body_500'
                                                        fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}
                                                        color={palette.text.primary}
                                                    >
                                                        {maskInfo(userDetails.mobile || '')}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '10px',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}
                                        >
                                            {isUserDataLoading ? (
                                                <Skeleton
                                                    variant='text'
                                                    animation="wave"
                                                    width={100}
                                                />
                                            ) : (
                                                <Typography
                                                    variant='h1'
                                                    fontSize={'32px'}
                                                    color={palette.text.primary}
                                                >
                                                    {isSwitchScreen ? `${toINR({
                                                        value: (totalAmount ?? ""),
                                                        locale,
                                                        currencyCode
                                                    })} / ${totalUnits ? Number(totalUnits).toFixed(4) : 0}` : `${toINR({
                                                        value: (totalAmount ?? ""),
                                                        locale,
                                                        currencyCode
                                                    })}`}
                                                </Typography>
                                            )}
                                            <Typography
                                                variant='body_500'
                                                color={palette.text.secondary}
                                            >
                                                Total {isSwitchScreen ? "Amount / Units" : 'Amount'}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', gap: '15px', flexDirection: 'row' }}>
                                            {/* {[USER_ROLES.RM].includes(role) && */}
                                            {![USER_ROLES.INVESTOR].includes(role) && (
                                                <>
                                                    {(isModuleAllowed({ value: "OrderRecommend", compareArr: permissions, objKey: "permissonCode" })) && (
                                                        <CustomeButton lookType={'outlined'} btnText={'Recommend'}
                                                            isLoading={["recomment"].includes(apiLoading)}
                                                            disabled={
                                                                isLoading ||
                                                                ["order", "investor"].includes(apiLoading) ||
                                                                riskPflChkLoading ||
                                                                isUserDataLoading ||
                                                                (formRef?.current?.values?.fund ?? []).length === 0 ||
                                                                (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                                                    ![USER_ROLES.INVESTOR].includes(role) &&
                                                                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                                                )
                                                            }
                                                            onClick={() => {
                                                                setOrderType('recomment')
                                                                formik.handleSubmit()
                                                            }} />
                                                    )}
                                                    {(isModuleAllowed({ value: "MFOrders", compareArr: permissions, objKey: "permissonCode" })) && (
                                                        <CustomeButton lookType={'contained'} btnText={'Place Order'}
                                                            disabled={
                                                                isLoading ||
                                                                ["recomment", "investor"].includes(apiLoading) ||
                                                                isUserDataLoading ||
                                                                riskPflChkLoading ||
                                                                (formRef?.current?.values?.fund ?? []).length === 0 ||
                                                                (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                                                    ![USER_ROLES.INVESTOR].includes(role) &&
                                                                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                                    MPOWER_ACCOUNT_TYPE_MASTER["ADV"]
                                                                )
                                                            }
                                                            isLoading={["order"].includes(apiLoading) || riskPflChkLoading}
                                                            onClick={() => {
                                                                setOrderType('order')
                                                                formik.handleSubmit()
                                                            }} />
                                                    )}
                                                </>
                                            )}
                                            {(
                                                [USER_ROLES.INVESTOR].includes(role) &&
                                                isModuleAllowed({ value: "MFOrders", compareArr: permissions, objKey: "permissonCode" })
                                            ) &&
                                                (
                                                    <CustomeButton lookType={'contained'} btnText={'Add to Cart'}
                                                        isLoading={["investor"].includes(apiLoading) || isLoading}
                                                        disabled={
                                                            isLoading ||
                                                            ["order", "recomment"].includes(apiLoading) ||
                                                            isUserDataLoading ||
                                                            (formRef?.current?.values?.fund ?? []).length === 0
                                                        }
                                                        onClick={() => {
                                                            setOrderType('investor')
                                                            formik.handleSubmit()
                                                        }}
                                                    />
                                                )}
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                            <ConfirmRecomment
                                isLoading={!!apiLoading}
                                open={confirmRecomment}
                                setClose={setConfirmRecomment}
                                title={orderType === 'recomment' ? "Confirm Recommendation!" : orderType === 'order' ? "Confirm!" : ''}
                                desc={orderType === 'recomment' ? "Are you sure you want to continue with this action ? You can see your old recommendations under recent recommendation tab." : "Are you sure you want to continue with this action ?"}
                                handleConfirm={() => orderType === 'recomment' ? handleConfromRecomment(formik.values) : orderType === 'order' && handleConformOrder(formik.values)}
                            />

                            <RiskProfilePopup open={riskProfilePopup} setClose={handleRiskProfilePopup} handleConfirmOrder={() => handleConformOrder(formik.values)} isLoading={apiLoading} text={riskPopupText} apiResObj={riskProfileCheckResponse} />

                            {/* Document Upload Dialog Start */}
                            <TransactionsDocumentUpload
                                open={isDocumentUploadDialogVisible}
                                onClose={handleDocumentUploadDialogClose}
                            />
                            {/* Document Upload Dialog End */}

                            {/* Multiple Orders from the same scheme/folio combination Dialog start */}
                            <ConfirmRecomment
                                open={isSameSchemesDialogOpen}
                                setClose={handleSameSchemeDialogClose}
                                title="Confirm!"
                                desc="Multiple Orders with the same scheme/folio combination. Please confirm before proceeding."
                                handleConfirm={handleSameSchemeDialogConfirm}
                            />
                            {/* Multiple Orders from the same scheme/folio combination Dialog end */}
                        </>
                    )
                }}
            </Formik>

            {cartPopup &&
                <AddtoCardPopup open={cartPopup} setClose={setCartPopup} handleSuccess={handleSuccess} />}
            <SuccessModal
                open={successModal}
                setClose={setSuccessModal}
                onclick={handleSuccessPopup}
                title="Success!"
                confirmBtnText={"Go to Dashboard"}
                desc={successMessage ?? ""}
            />
            <FiveSchemeErrorMessage handleCloseFiveSchemesDialog={handleCloseFiveSchemesDialog} isFiveSchemesDialogVisible={isFiveSchemesDialogVisible} />
            <ValidateDialogBox handleValidationDialogClose={handleValidationDialogClose} validationErrorsArray={validationErrorsArray} isValidationDialogVisible={isValidationDialogVisible} />

            {/* Document Upload Error Dialog Start */}
            <Dialog
                aria-labelledby="error-dialog"
                open={isDocumentUploadErrorDialogVisible}
                PaperProps={{
                    sx: {
                        maxWidth: '550px',
                        width: "100%",
                        borderRadius: "12px",
                        padding: "24px",
                        backgroundColor: palette.common.white
                    },
                }}
            >
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "12px",
                        padding: "15px",
                        overflow: "hidden"
                    }}
                >
                    <FailureIcon width="35" height="35" />
                    <Typography
                        variant="h2"
                        sx={{
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: palette.text.primary
                        }}
                    >
                        Error!
                    </Typography>
                    <Typography
                        variant="subtitle_400"
                        sx={{
                            lineHeight: "22px",
                            letterSpacing: "0.02px",
                            color: palette.text.secondary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        }}
                    >
                        Please upload minimum 1 document
                    </Typography>
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: "0px",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleDocumentUploadErrorDialogClose}
                        sx={{
                            ...typography.body_500,
                            fontWeight: 600,
                            lineHeight: "20px",
                            color: palette.common.white,
                            borderRadius: "4px",
                            padding: "13px 20px",
                            backgroundColor: palette.primary[500]
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Document Upload Error Dialog End */}

            {/* Transaction Not Allowed Error Dialog Start */}
            <Dialog
                aria-labelledby="error-dialog"
                open={isTransactionNotAllowedDialogVisible}
                PaperProps={{
                    sx: {
                        maxWidth: '550px',
                        width: "100%",
                        borderRadius: "12px",
                        padding: "24px",
                        backgroundColor: palette.common.white,
                        maxHeight: "50%"
                    },
                }}
            >
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "12px",
                        padding: "15px",
                        overflow: "hidden"
                    }}
                >
                    <FailureIcon width="35" height="35" />
                    <Typography
                        variant="h2"
                        sx={{
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: palette.text.primary
                        }}
                    >
                        Error!
                    </Typography>
                    <Typography
                        variant="body_600"
                        sx={{
                            lineHeight: "22px",
                            letterSpacing: "0.02px",
                            color: palette.text.secondary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        }}
                    >
                        {isSwitchScreen ? "Switch" : "STP"} transaction is not allowed for below schemes:
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "10px",
                            marginTop: "20px",
                            overflowY: "auto"
                        }}
                    >
                        {(stpSchemesTxnNotAllowed ?? []).map((obj: any) => (
                            <Typography
                                key={obj?.isinCode ?? ""}
                                variant="body_500"
                                sx={{
                                    lineHeight: "22px",
                                    letterSpacing: "0.02px",
                                    color: palette.text.secondary,
                                    textAlign: "center",
                                    paddingLeft: "10px",
                                    paddingRight: "10px"
                                }}
                            >
                                {obj?.fundName ?? ""}
                            </Typography>
                        ))}
                    </Box>
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: "0px",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleTransactionNotAllowedDialogClose}
                        sx={{
                            ...typography.body_500,
                            fontWeight: 600,
                            lineHeight: "20px",
                            color: palette.common.white,
                            borderRadius: "4px",
                            padding: "13px 20px",
                            backgroundColor: palette.primary[500]
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Transaction Not Allowed Error Dialog End */}
            {/* Add More Funds start */}
            {isAddMoreHoldingDialogOpen && (
                <HoldingFundMore
                    {...{
                        open: isAddMoreHoldingDialogOpen,
                        setOpen: setAddMoreHoldingDialogOpen,
                        clientCode,
                        holdingsData,
                        setHoldingsData,
                        handleProceed
                    }}
                />
            )}
            {/* Add More Funds end */}
        </>
    )
}

export default SwitchAndStp